// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_tL1","cls2":"PaperAbstract-cls2_KjO PaperAbstract-cls1_tL1"};